import DOMPurify from "dompurify";

const TIPTAP_ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "s",
  "strike",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "ul",
  "ol",
  "li",
  "blockquote",
  "pre",
  "code",
  "hr",
  "a",
];

const TIPTAP_ALLOWED_ATTR = ["style", "class", "href", "target", "rel"];

const sanitizeConfig: DOMPurify.Config = {
  ALLOWED_TAGS: TIPTAP_ALLOWED_TAGS,
  ALLOWED_ATTR: TIPTAP_ALLOWED_ATTR,
};

export function sanitizeHtml(html: string | null | undefined): string {
  if (!html || typeof html !== "string") {
    return "";
  }

  return DOMPurify.sanitize(html, sanitizeConfig);
}
